<div class="vh_center mt-4">
  <div col="12">
    <div style=" margin:0px; " class="vh_center">
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
    </div>
  </div>
</div>
<div class="vh_center mt-2">
  <div col="12">
    <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
      <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
      <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
      <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
    </div>
  </div>
</div>
<div class="page_bottom_space">
  <div class="p-5">
    <div class="col-12 d-grid gap-2">
      <div type="button" class="btn btn-warning fw6 cursor-default" style="cursor: inherit;">
        Review & Confirm
      </div>
    </div>
    @if (commonService.commonMainObj.finalBomDataToPurchase?.issueFound != null) {
      <div class="col-12 text-center">
        <div class="col-8 offset-2 mt-3 mb-3" id="error-msg-sec1" >
          <div style="color: red;">Note: All BOM issues were not resolved. Components quote displayed in the table below is a budgetary price and only covers the components that does not have issues.</div>
        </div>
      </div>
    }
    <div class="text-center fs-6 mt-3">
      <p>Please review your order information and confirm below by clicking on <b>"Place My Order"</b> button.</p>
    </div>
    <div class="col-12 mb-3 justify-content-center" id="budgetaryQuoteTableSec">
      <div class="col-sm-12">
        <div class="table-responsive" id="budgetaryQuoteTable">
          <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
            <thead>
              <tr>
                <th align="center" valign="middle" class="bg_yellow">Line Item</th>
                <th align="center" valign="middle" class="bg_yellow">Part# / Rev</th>
                <th align="center" valign="middle" class="bg_yellow">Quantity</th>
                <th align="center" valign="middle" class="bg_yellow">Turn Time</th>
                <th align="center" valign="middle" class="bg_yellow">Unit Price</th>
                <th align="center" valign="middle" class="bg_yellow">Lot Price</th>
                <th align="center" valign="middle" class="bg_yellow">NRE</th>
                <th align="center" valign="middle" class="bg_yellow">Electrical Testing</th>
                <th align="center" valign="middle" class="bg_yellow">MISC / Others</th>
                <th align="center" valign="middle" class="bg_yellow">Sub-total</th>
                <th align="center" valign="middle" class="bg_yellow">Tax</th>
                <th align="center" valign="middle" class="bg_yellow">Total</th>
              </tr>
            </thead>
            @if (commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems != null && commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems != '' ) {
              <tbody id="quote-display-tbody">
                @if (commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0]) {
                  <tr>
                    <td align="center" valign="top">PCB FABRICATION</td>
                    <td align="center" valign="top">{{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].partNo}} / {{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].partRevNo
                    }}</td>
                    <td align="center" valign="top">{{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].quantity}}</td>
                    <td align="center" valign="top">{{fabTurnTimeDisplay}}</td>
                    <td align="center" valign="top">${{to_Float(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].unitPrice).toFixed(2)}}</td>
                    <td align="center" valign="top">${{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].quantity!=null && commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].unitPrice!=null ? (to_Num(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].quantity)*to_Float(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].unitPrice)).toFixed(2) :"0.00" }}</td>
                    <td align="center" valign="top">${{"0.00"}}</td>
                    <td align="center" valign="top">${{ (commonService.commonMainObj.electricalTesting=="No")?"0.00":commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].electricalTestingPrice}}</td>
                    <!-- <td align="center" valign="top">${{commonService.commonMainObj.pcbPromoDiscount ? '-' + commonService.commonMainObj.pcbPromoDiscount:"0.00"}}</td> -->
                    <td align="center" valign="top">@if (commonService.commonMainObj.pcbPromoDiscount) {
                      <span>-</span>
                    }${{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].miscOrOther > 0 ? (to_Float(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].miscOrOther).toFixed(2)) : commonService.commonMainObj.pcbPromoDiscount ? (to_Float(commonService.commonMainObj.pcbPromoDiscount).toFixed(2)) : to_Float(0.00).toFixed(2)}}</td>
                    <td align="center" valign="top">${{to_Float(pcbSubTotal).toFixed(2)}}</td>
                    <td align="center" valign="top">${{(pcbTax).toFixed(2)}}</td>
                    <td align="right" valign="top">${{(pcbTotal).toFixed(2)}}</td>
                  </tr>
                }
                @if (commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1]) {
                  <tr>
                    <td align="center" valign="top"> ASSEMBLY </td>
                    <td align="center" valign="top">{{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].partNo}}  / {{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].partRevNo
                    }}</td>
                    <td align="center" valign="top">{{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].quantity}}</td>
                    <td align="center" valign="top">{{assTurnTimeDisplay}}</td>
                    <td align="center" valign="top">${{to_Float(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].unitPrice).toFixed(2)}}</td>
                    <td align="center" valign="top">${{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].quantity!=null && commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].unitPrice!=null ? (to_Num(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].quantity)*to_Float(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].unitPrice)).toFixed(2) :"0.00" }}</td>
                    <td align="center" valign="top">${{"0.00"}}</td>
                    <td align="center" valign="top">-</td>
                    <!-- <td align="center" valign="top">${{commonService.commonMainObj.assemblyPromoDiscount ?  '-' + commonService.commonMainObj.assemblyPromoDiscount:"0.00"}}</td> -->
                    <td align="center" valign="top">@if (commonService.commonMainObj.pcbAssemblyPromo && commonService.commonMainObj.assemblyPromoDiscount != 0) {
                      <span>-</span>
                    }${{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].miscOrOther > 0 && commonService.commonMainObj.assemblyPromoDiscount ? (to_Float(commonService.commonMainObj.assemblyPromoDiscount) - to_Float(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].miscOrOther)).toFixed(2) : commonService.commonMainObj.assemblyPromoDiscount ? to_Float(commonService.commonMainObj.assemblyPromoDiscount).toFixed(2)  : (commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].miscOrOther)}}</td>
                    <td align="center" valign="top">${{to_Float(assemblySubTotal).toFixed(2)}}</td>
                    <td align="center" valign="top">${{(assemblyTax).toFixed(2)}}</td>
                    <td align="right" valign="top">${{(pcbAssemblyTotal).toFixed(2)}}</td>
                  </tr>
                }
                @if (commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2]) {
                  <tr>
                    <td align="center" valign="top">COMPONENTS</td>
                    <td align="center" valign="top">{{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].partNo}} / {{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].partRevNo
                    }}</td>
                    <td align="center" valign="top">{{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].quantity}}</td>
                    <td align="center" valign="top">-</td>
                    <td align="center" valign="top">-</td>
                    <!-- commented for OFP-1210 -->
                    <!-- <td align="center" valign="top">${{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].quantity!=null && commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].unitPrice!=null ? (to_Num(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].quantity)*to_Float(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].unitPrice)).toFixed(2) :"0.00" }}</td> -->
                    <td align="center" valign="top">${{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].quantity!=null && commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].unitPrice!=null ? commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].boardPrice:"0.00"}}</td>
                    <td align="center" valign="top">${{"0.00"}}</td>
                    <td align="center" valign="top">-</td>
                    <!-- <td align="center" valign="top">${{commonService.commonMainObj.componentPromoDiscount ? '-'+ commonService.commonMainObj.componentPromoDiscount:"0.00"}}</td> -->
                    <td align="center" valign="top">@if (commonService.commonMainObj.pcbAssemblyPromo && commonService.commonMainObj.componentPromoDiscount != 0) {
                      <span>-</span>
                    }${{commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].miscOrOther > 0 && commonService.commonMainObj.componentPromoDiscount ? (to_Float(commonService.commonMainObj.componentPromoDiscount) - to_Float(commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].miscOrOther)).toFixed(2) : commonService.commonMainObj.componentPromoDiscount ? to_Float(commonService.commonMainObj.componentPromoDiscount).toFixed(2) : (commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].miscOrOther)}}</td>
                    <td align="center" valign="top">${{to_Float(componentSubTotal).toFixed(2)}}</td>
                    <td align="center" valign="top">${{(componentTax).toFixed(2)}}</td>
                    <td align="right" valign="top">${{(componentTotal).toFixed(2)}}</td>
                  </tr>
                }
                <tr>
                  <td align="left" valign="middle" colspan="2" style="padding:10px;border-right:0px; display: none;"></td>
                  <td align="right" valign="middle" colspan="3" style="padding:10px;border-right:0px;"><strong>Total Turn Time</strong></td>
                  <td align="center" valign="middle" style="border-right:none;" id="quote-display-total-turntime-td">{{this.total_turntime}} Day(s)</td>
                  <td align="right" valign="top" colspan="7"><strong>Shipping and handling charges</strong>
                  @if (commonService.commonMainObj.shippingAccountNumber) {
                    <div>FedEx/UPS account number: {{commonService.commonMainObj.shippingAccountNumber}}</div>
                  }
                  @if (commonService.commonMainObj.shippingPromo == true && !commonService.commonMainObj.shippingAccountNumber) {
                    <div>Shipping discount</div>
                  }
                </td>
                <td align="right" valign="top">${{this.commonService.commonMainObj.shippingCost!=null && this.commonService.commonMainObj.shippingCost!=""?this.commonService.commonMainObj.shippingCost:"0.00"}}
                  @if (commonService.commonMainObj.shippingPromo == true && !commonService.commonMainObj.shippingAccountNumber) {
                    <div >-${{commonService.commonMainObj.shippingPromoDiscount}}</div>
                  }
                </td>
              </tr>
              <!-- <tr>
              <td align="right" valign="middle" colspan="11">Promo code</td>
              <td align="center" valign="top"><input readonly="true" size="10" style="font-size:16px;font-weight:bold;border:none;text-align:center;" type="text" name="txtLotTotal" id="txtLotTotal" value=""></td>
            </tr> -->
            <tr>
              <td align="right" valign="middle" colspan="11"><strong>Total Cost</strong></td>
              <td align="right" valign="top"><strong>${{(orderTotal).toFixed(2)}}</strong></td>
            </tr>
          </tbody>
        }
      </table>
    </div>
  </div>
</div>
<div class="p-1 bg_gray">
  <p class="m-1 text-white">Order Details</p>
</div>
<div>
  <div class="col-12" style="display: flex;">
    <div class="box_sec_billing" [ngClass]="commonService.commonMainObj.isNotAuthChecked ? 'col-6' : 'col-4' ">
      <div class="half-sec text-center">
        <p class="yellow-txt mt-1 mb-1"><strong>Billing Info</strong></p>
        <div class="m-2 mt-0 text-lg-start">
          <div><strong>{{apiService.apiMainObj.selectedBillingAddress.firstName}} {{apiService.apiMainObj.selectedBillingAddress.lastName}}</strong></div>
          <p class="m-0">{{apiService.apiMainObj.selectedBillingAddress.addressLine1}},{{apiService.apiMainObj.selectedBillingAddress.addressLine2}}</p>
          <p class="m-0">{{apiService.apiMainObj.selectedBillingAddress.city}}, {{apiService.apiMainObj.selectedBillingAddress.state}}{{apiService.apiMainObj.selectedBillingAddress.zip}}</p>
          <p class="m-0">{{apiService.apiMainObj.selectedBillingAddress.country}}</p>
          <p class="m-0">Phone: {{apiService.apiMainObj.selectedBillingAddress.phoneNumber}}</p>
          <p class="m-0">Email: {{apiService.apiMainObj.selectedBillingAddress.email}}</p>
        </div>
        @if (commonService.commonMainObj.isNotAuthChecked) {
          <div class="un-auth-text">
            Payment info to be filled by <b>{{this.commonService.commonMainObj.purchasingPersonDetails.firstName}} {{this.commonService.commonMainObj.purchasingPersonDetails.lastName}}</b><br>
            A link will be sent to <b style="text-decoration: underline;" class="text-primary">{{this.commonService.commonMainObj.purchasingPersonDetails.email}}</b> once you place this order.<br>
            Order will be in “Pending payment“ status until payment info is finalized.<br>
            <b>Remarks to {{this.commonService.commonMainObj.purchasingPersonDetails.firstName}} {{this.commonService.commonMainObj.purchasingPersonDetails.lastName}} : {{commonService.commonMainObj.purchasingPersonDetails.remarks?commonService.commonMainObj.purchasingPersonDetails.remarks: "NA"}}</b>
          </div>
        }
      </div>
    </div>
    <div class="col-4 box_sec_pcb">
      <div class="half-sec text-center">
        <p class="yellow-txt mt-1 mb-1"><strong>Shipping Info</strong></p>
        <div class="m-2 mt-0 text-lg-start">
          <div><strong>{{apiService.apiMainObj.selectedShippingAddress.firstName}} {{apiService.apiMainObj.selectedShippingAddress.lastName}}</strong></div>
          <p class="m-0">{{apiService.apiMainObj.selectedShippingAddress.addressLine1}}, {{apiService.apiMainObj.selectedShippingAddress.addressLine2}}</p>
          <p class="m-0">{{apiService.apiMainObj.selectedShippingAddress.city}}, {{apiService.apiMainObj.selectedShippingAddress.state}} {{apiService.apiMainObj.selectedShippingAddress.zip}}</p>
          <p class="m-0">{{apiService.apiMainObj.selectedShippingAddress.country}}</p>
          <p class="m-0">Phone: {{apiService.apiMainObj.selectedShippingAddress.phoneNumber}}</p>
          <p class="m-0">Email: {{apiService.apiMainObj.selectedShippingAddress.email}}</p>
        </div>
      </div>
    </div>
    <div class="col-4 box_sec_assembly">
      <div class="half-sec text-center">
        <p class="yellow-txt mt-1 mb-1"><strong>Designer Info</strong></p>
        <div class="m-2 mt-0 text-lg-start">
          <div><strong>{{apiService.apiMainObj.selectedDesignerAddress.firstName}} {{apiService.apiMainObj.selectedDesignerAddress.lastName}}</strong></div>
          <p class="m-0">{{apiService.apiMainObj.selectedDesignerAddress.addressLine1}}, {{apiService.apiMainObj.selectedDesignerAddress.addressLine2}}</p>
          <p class="m-0">{{apiService.apiMainObj.selectedDesignerAddress.city}}, {{apiService.apiMainObj.selectedDesignerAddress.state}} {{apiService.apiMainObj.selectedDesignerAddress.zip}}</p>
          <p class="m-0">{{apiService.apiMainObj.selectedDesignerAddress.country}}</p>
          <p class="m-0">Phone: {{apiService.apiMainObj.selectedDesignerAddress.phoneNumber}}</p>
          <p class="m-0">Email: {{apiService.apiMainObj.selectedDesignerAddress.email}}</p>
        </div>
      </div>
    </div>
   
  </div>
</div>
<div class="col-12 mb-5" style="display: flex;">
  <div class="col-6 box_sec_pcb">
    <div class="p-1 bg_gray"><p class="m-1 text-white">Uploaded File</p></div>
    <div class="half-sec-small text-lg-start">
      <div class="mt-3"><strong>Design File Name: {{commonService.commonMainObj.uploadedFilesData.filename}} </strong></div>
      <!-- <div *ngIf="!commonService.commonMainObj.onlyPcb">
      <div class="filename" *ngIf="commonService.commonMainObj.customBomFileName" ><strong>BOM file name: </strong> <span class="Fname" style="cursor: pointer;" (click)="DownloadBomFile(commonService.commonMainObj.bomFileName)">{{commonService.commonMainObj.customBomFileName.split('.').slice(0, -1).join('.')}}</span></div>
      <div class="filename" *ngIf="commonService.commonMainObj.typeOfBomFile == 'auto-generated'" ><strong>BOM file name: </strong> <span class="Fname" style="cursor: pointer;" (click)="DownloadBomFile(commonService.commonMainObj.bomFileName)">{{commonService.commonMainObj.designFile}}</span></div>
    </div> -->
  </div>
</div>
<div class="col-6 box_sec_assembly">
  <div class="p-1 bg_gray"><p class="m-1 text-white">Shipping Note</p></div>
  <div class="half-sec-small text-lg-start">
    <p class="mt-3">{{commonService.commonMainObj.shippingNotes}}</p>
  </div>
</div>
</div>
<div class="col-12 mb-5">
  @if (commonService.commonMainObj.onlyPcb) {
    <div class="p-1 bg_gray cursor-pointer" (click)="specDetailsHide()" ><p class="m-1 text-white"><i class="fa fa-chevron-down fs-5"></i> Your PCB Specifications</p></div>
  }
  @if (!commonService.commonMainObj.onlyPcb) {
    <div class="p-1 bg_gray cursor-pointer" (click)="specDetailsHide()" ><p class="m-1 text-white"><i class="fa fa-chevron-down fs-5"></i> Your PCB/ASSEMBLY Specifications</p></div>
  }
  <div class="half-sec-specs" [hidden]="isHidden">
    <div class="row">
      <div class="col-3">
        <p class=""><strong>Product Name:</strong></p>
      </div>
      <div class="col-8">
        <p>Web product (PCB Fabrication)</p>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <p class=""><strong>Product Description:</strong></p>
      </div>
      <div class="col-8">
        <table id="spec-details-table" class="specs-table">
          @for (sd of pcbPartDataSpecs; track sd; let i = $index; let odd = $odd) {
            <tr [hidden]='odd'>
              <td><b>{{pcbPartDataSpecs[i].dname}}</b></td>
              <td>{{pcbPartDataSpecs[i].value}}</td>
              <td><b>{{pcbPartDataSpecs[i+1]?.dname}}</b></td>
              <td>{{pcbPartDataSpecs[i+1]?.value}}</td>
            </tr>
          }
        </table>
      </div>
    </div>
    @if (!commonService.commonMainObj.onlyPcb) {
      <div class="col-12 p-2">
        <div class="p-1 bg_gray"><p class="m-1 text-white">Assembly Specs Information</p></div>
        <div class="half-sec-specs">
          <div class="row">
            <div class="col-3">
              <p class=""><strong>Product Name:</strong></p>
            </div>
            <div class="col-8">
              <p>Web product (Assembly labor)</p>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <p class=""><strong>Product Description:</strong></p>
            </div>
            <div class="col-8">
              @if (commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1]) {
                <table  class="specs-table" >
                  <tr>
                    <td> <b>Number of assemblies ( Assembly + Components )</b> </td>
                    <td> {{commonService.commonMainObj.selectedAssemblyQuantity  }} </td>
                  </tr>
                  <tr>
                    <td> <b>Assembly turn-time</b> </td>
                    <td> {{commonService.commonMainObj.selectedAssemblyTurntime  }}</td>
                  </tr>
                  <tr>
                    <td> <b>Number of sides to be assembled (One side/Two sides)</b> </td>
                    <td> {{commonService.commonMainObj.assemblySides}} </td>
                  </tr>
                  <tr>
                    <td> <b>Board dimensions(X * Y)</b> </td>
                    <td> {{commonService.commonMainObj.savedBoardDimensions}}</td>
                  </tr>
                </table>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (!commonService.commonMainObj.onlyPcb) {
      <div class="col-12 p-2">
        <div class="p-1 bg_gray"><p class="m-1 text-white">Component Specs Information</p></div>
        <div class="half-sec-specs">
          <div class="row">
            <div class="col-3">
              <p class=""><strong>Product Name:</strong></p>
            </div>
            <div class="col-8">
              <p>Web product (Components)</p>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <p class=""><strong>Product description:</strong></p>
            </div>
            <div class="col-8">
              @if (commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2]) {
                <table  class="specs-table" >
                  <tr>
                    <td> <b>Layers</b> </td>
                    <td> {{layerValToDisplay}}</td>
                  </tr>
                  <tr>
                    <td> <b>Board dimensions(X * Y)</b> </td>
                    <td> {{commonService.commonMainObj.savedBoardDimensions}}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>BOM file name</b>
                    </td>
                    <td>
                      @if (!commonService.commonMainObj.onlyPcb) {
                        <div>
                          <div class="filename">{{commonService.commonMainObj.uploadedBomFileName}}</div>
                          <!-- <div class="filename" *ngIf="remoteService.typeOfBomFile == 'auto-generated'" >{{remoteService.designFile}}</div> -->
                        </div>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Number of BOM line items charged</b>
                    </td>
                    <td>
                      {{numOfBomItemsCharging}}
                    </td>
                  </tr>
                </table>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
<div class="col-12 mb-5" style="display: flex;">  
  <div class="col-6 box_sec_pcb" [ngClass]="commonService.commonMainObj.isNotAuthChecked && commonService.commonMainObj.paymentserviceAvailable ? 'disable-div' : '' ">
    <div class=" p-1 bg_gray"><p class="m-1 text-white">Payment Method Information</p></div>
    <div class="half-sec-specs ">
      <div [ngClass]="commonService.commonMainObj.hidePaymentSection? 'hide-div' : ''">
        <form [formGroup]="paymentForm">
          <div style="margin-left: 10px;margin-bottom: 5px;">
            <label style="color:#000000" for="cardName">Name on Card</label>
            <input [(ngModel)]="commonService.commonMainObj.cardHolderName"  type="text" class="form-control grey-input" id="cardName" #cardName formControlName="nameOnCard" autocomplete="cc-name" required (keyup)="commonService.removeRedBorder('cardName')">
          </div>
          <div class="validation-errors mb-2" style="margin-left: 12px;">
            @for (validation of payment_validation_messages.nameOnCard; track validation) {
              @if (paymentForm.get('nameOnCard')?.hasError(validation.type) && (paymentForm.get('nameOnCard')?.dirty || paymentForm.get('nameOnCard')?.touched)) {
                <div class="error-message" style="color: #dc3545;font-size: 14px;">
                  {{ validation.message }}
                </div>
              }
            }
          </div>
        </form>
        <div style="display: none;">
          <input type="text" id="ccid1000" #ccid />
        </div>
      </div>
      <div class="fp-container">
        <div id="iframeLoader" class="iframe-loader"></div>
        <div class="col-12  margin15 paddingzero" id="cardPaymentTokenization" style=" position: relative;"></div>
      </div>
      <input type="hidden" id="fpServiceBaseURL" value="<%=freedomPayServiceBaseUrl%>"/>
      <input type="hidden" id="fpControlsInitUrl" value="<%=fpControlsInitUrl%>"/>
      <input type="hidden" id="strWebAppURL" value="<%=strWebAppURL%>"/>
      <input type="hidden" id="strParentOrder" value=""/>
      <input type="hidden" id="redirectURL" value=""/>
      <input type="hidden" id="fpSessionCreatedAt" value=""/>
      <input type="hidden" id="fpIframeId" value=""/>
      <input type="hidden" id="fpPaymentSuccess" value=""/>
      <input type="hidden" id="fpTargetDomain" value="{{apiService.fpHpcBaseUrl}}">
    </div>
  </div>
  <div class="col-6 box_sec_assembly">
    <div class=" p-1 bg_gray"><p class="m-1 text-white">NOT AUTHORIZED TO PURCHASE?</p>
      <span class="text-white">(Send link to someone else to complete the payment)</span>
    </div>
    <div class="half-sec-specs"> 
      <div class="card-body p-3">
        <div class="green-txt mb-3">
        We allow you to go ahead and place the order and let the purchasing person complete the payment later.</div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" [(ngModel)]="commonService.commonMainObj.isNotAuthChecked" (change)="notAuthSelection($event)" id="not_auth_purchases">
          <label class="form-check-label" >
            I don't have all the billing/credit card info. It will be filled by my purchasing person.
          </label>
        </div>
        @if (commonService.commonMainObj.isNotAuthChecked) {
          <div class="">
            <form [formGroup]="unAuthorizedForm">
              <label> Send link to </label>
              <div class="row g-2">
                <div class="col-md">
                  <div class="">
                    <input [(ngModel)]="this.commonService.commonMainObj.purchasingPersonDetails.firstName"  type="text" class="form-control" id="not_auth_first_name" #notAuthFirstName formControlName="unAuthFirstName" autocomplete="off" required (keyup)="commonService.removeRedBorder('not_auth_first_name')" placeholder="First Name">
                  </div>
                  <div class="validation-errors mb-2">
                    @for (validation of not_auth_validation_messages.unAuthFirstName; track validation) {
                      @if (unAuthorizedForm.get('unAuthFirstName')?.hasError(validation.type) && (unAuthorizedForm.get('unAuthFirstName')?.dirty || unAuthorizedForm.get('unAuthFirstName')?.touched)) {
                        <div class="error-message">
                          {{ validation.message }}
                        </div>
                      }
                    }
                  </div>
                </div>
                <div class="col-md">
                  <div class="">
                    <input [(ngModel)]="commonService.commonMainObj.purchasingPersonDetails.lastName"  type="text" class="form-control" id="not_auth_last_name" #notAuthLastName formControlName="unAuthLasttName" autocomplete="off" placeholder="Last Name">
                  </div>
                  <div class="validation-errors mb-2">
                    @for (validation of not_auth_validation_messages.unAuthLasttName; track validation) {
                      @if (unAuthorizedForm.get('unAuthLasttName')?.hasError(validation.type) && (unAuthorizedForm.get('unAuthLasttName')?.dirty || unAuthorizedForm.get('unAuthLasttName')?.touched)) {
                        <div class="error-message">
                          {{ validation.message }}
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <label for="card_name">Email</label>
                <input [(ngModel)]="commonService.commonMainObj.purchasingPersonDetails.email" type="text" class="form-control" id="not_auth_email" #notAuthEmail formControlName="unAuthEmail" autocomplete="off" required (keyup)="commonService.removeRedBorder('not_auth_email'); validateUnauthDomain(commonService.commonMainObj.purchasingPersonDetails.email);" placeholder="Email">
              </div>
              @if (!unauthEmailisValid) {
                <div class="validation-errors mb-2">
                  @for (validation of not_auth_validation_messages.unAuthEmail; track validation) {
                    @if (unAuthorizedForm.get('unAuthEmail')?.hasError(validation.type) && (unAuthorizedForm.get('unAuthEmail')?.dirty || unAuthorizedForm.get('unAuthEmail')?.touched)) {
                      <div class="error-message">
                        {{ validation.message }}
                      </div>
                    }
                  }
                </div>
              }
              @if (unauthEmailisValid) {
                <p class="validation-errors mb-2 error-message">{{commonService.commonMainObj.invalidEmailErrorMsg}}</p>
              }
              <div class="mt-2">
                <label for="card_name">Any remarks to your purchasing person</label>
                <textarea [(ngModel)]="commonService.commonMainObj.purchasingPersonDetails.remarks" rows="3" class="form-control" id="not_auth_remark" #notAuthRemark formControlName="unAuthRemark" autocomplete="off"  placeholder="Remarks"></textarea>
              </div>
            <div class="mt-2 mb-3">
              <div class="text-success fw-b">I understand that order will stay in "Pending" status at Sierra Circuits till payment info is finalized.</div>
              <div class="form-check mt-3">
                <input class="form-check-input agree-check" type="checkbox" value="" id="not_auth_agree" #notAuthAgreed [(ngModel)]="commonService.commonMainObj.purchasingPersonDetails.paymentPending" formControlName="unAuthAgree" (change)="authAgreedCheck($event)">
                <label class="form-check-label" for="not_auth_agree"> <span class="text-success fw-b">Agreed</span>
              </label>
            </div>
          </div>
          <div class="validation-errors mb-2">
            @for (validation of not_auth_validation_messages.unAuthAgree; track validation) {
              @if (unAuthorizedForm.get('unAuthAgree')?.hasError(validation.type) && (unAuthorizedForm.get('unAuthAgree')?.dirty || unAuthorizedForm.get('unAuthAgree')?.touched)) {
                <div class="error-message">
                  {{ validation.message }}
                </div>
              }
            }
          </div>
            </form>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="col-12 text-lg-end mt-3">
  <button type="button" class="btn btn-custom m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="goToOrderDetailsPage()"> <b>Back</b>
</button>
<button type="button" id="placeOrderBtnId" class="btn btn_forest_green_custom btn-custom m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="goToStatusPage()"> <b>Place My Order</b>
</button>

</div>
</div>
</div>

<app-footer></app-footer>
